/* OBFUSCATED CODE - INTELLECTUAL PROPERTY PROTECTED */
'use client';
import React from 'react';
import styles from './PanelToggle.module.css';
export default function PanelToggle({
    isExpanded = false,
    onClick,
    className = ''
}) {
    const toggleClasses = [
        styles.panelToggle,
        isExpanded ? styles.expanded : '',
        className
    ].filter(Boolean).join(' ');
    return (
        <div
            className={toggleClasses}
            onClick={onClick}
            title={isExpanded ? 'Collapse panel' : 'Expand panel'}
        />
    );
}
